import React, { useState } from "react";
import emailjs from "emailjs-com";
import styled from "styled-components";

import FullButton from "../Buttons/FullButton";

const initialState = {
  name: "",
  email: "",
  message: "",
};

export default function Contact() {
  const [{ name, email, message }, setState] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState({ ...initialState });
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(name, email, message);
    emailjs
      .sendForm(
        "service_1eqzpaa",
        "template_rjq6znq",
        e.target,
        "XgOFa8ARi32eX1QTj"
      )
      .then(
        (result) => {
          console.log(result.text);
          clearState();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  return (
    <Wrapper id="contact">
      <div
        className="lightBg radius6"
        style={{
          marginTop: 100,
          paddingInline: 50
        }}
      >
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Contactarme</h1>
          </HeaderInfo>
          <div className="row" style={{ paddingBottom: "70px" }}>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-12">
              <Form
                onSubmit={handleSubmit}
                name="sentMessage"
                validate
              >
                <div className="form-group">
                  <label className="font13">Nombre:</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    className="form-control font20 extraBold"
                    placeholder="Nombre"
                    required
                    onChange={handleChange}
                  />
                  <p className="help-block text-danger"></p>
                </div>
                <div className="form-group">
                  <label className="font13">Correo:</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="form-control font20 extraBold"
                    placeholder="Correo"
                    required
                    onChange={handleChange}
                  />
                  <p className="help-block text-danger"></p>
                </div>
                <div className="form-group">
                  <label className="font13">Mensaje:</label>
                  <textarea
                    name="message"
                    id="message"
                    className="form-control font20 extraBold"
                    rows="4"
                    placeholder="Mensaje"
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <SumbitWrapper className="flex">
                  <ButtonInput
                    type="submit"
                    value=""
                    className="pointer animate radius8"
                    style={{ maxWidth: "220px" }}
                  >
                    Enviar Mensaje
                  </ButtonInput>
                </SumbitWrapper>
              </Form>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-12">
              <ButtonsRow className="flexNullCenter" style={{ margin: "70px 0 30px" }}>
                <div style={{ width: "100%" }}>
                  <FullButton
                    title="+52 443 374 5594"
                    action={() => {
                      return window.open('tel:+524433745594')
                    }}
                    border
                  />
                </div>
                <div style={{ width: "100%" }}>
                  <FullButton
                    title="Abrir en Facebook"
                    action={() => {
                      return window.open('https://www.facebook.com/Bigdreamsmkt', '_blank')
                    }}
                    border
                  />
                </div>
                <div style={{ width: "100%" }}>
                  <FullButton
                    title="Abrir en X"
                    action={() => {
                      return window.open('https://x.com/BigDreamsMkt', '_blank')
                    }}
                    border
                  />
                </div>
                <div style={{ width: "100%" }}>
                  <FullButton
                    title="Abrir en LinkedIn"
                    action={() => {
                      return window.open('https://linkedin.com/in/salvadorcortesa/', '_blank')
                    }}
                    border
                  />
                </div>
              </ButtonsRow>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  max-width: 1080px;
  margin: 0 auto 80px;
`;
const HeaderInfo = styled.div`
  padding: 70px 0 30px 0;
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const Form = styled.form`
  padding: 70px 0 30px 0;
  input,
  textarea {
    width: 100%;
    background-color: transparent;
    border: 0px;
    outline: none;
    box-shadow: none;
    border-bottom: 1px solid #707070;
    height: 30px;
    margin-bottom: 30px;
  }
  textarea {
    min-height: 100px;
  }
  @media (max-width: 860px) {
    padding: 30px 0;
  }
`;
const ButtonInput = styled.button`
  border: 1px solid #0A97D5;
  background-color: #0A97D5;
  width: 100%;
  padding: 15px;
  outline: none;
  color: #fff;
  :hover {
    background-color: #034388;
    border: 1px solid #0A97D5;
    color: #fff;
  }
  @media (max-width: 991px) {
    margin: 0 auto;
  }
`;
const ButtonsRow = styled.div`
  width: 100%;
  gap: 15px;
  @media (max-width: 860px) {
    flex-direction: column;
    justify-content: space-between;
  }
`;
const SumbitWrapper = styled.div`
  @media (max-width: 991px) {
    width: 100%;
    margin-bottom: 50px;
  }
`;









